import { Button, Colors, IcChevronLeft, IcTrash, IcChevronRight, IcScreen } from 'basic-ui-lib';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import styled from 'styled-components';
import { useMediaExplorer } from 'modules/media/services/hooks/useMediaExplorer';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';
import ModalConfirm, { useModalConfirmRef } from 'widgets/ModalConfirm';
import { IMediaItem } from 'modules/media/interfaces/api';
import mediaApis from 'modules/media/services/apis';
import toast from 'utils/toast';
import navigate from 'utils/navigate';
import { getMessageError } from 'services/response';

const MediaDetail = () => {
  const [data, mutate] = useGetManageLibrary(true);
  const { items } = useMediaExplorer(data, mutate, true);

  const location = useLocation();
  const { index: initialIndex } = location.state || {};
  const mediaItems = items.filter((i) => i.type !== 'FOLDER');
  const modalConfirmRef = useModalConfirmRef();
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  const item = mediaItems[currentIndex];

  const handleNext = () => {
    setCurrentIndex((prev: number) => (prev + 1) % mediaItems.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev: number) => (prev === 0 ? mediaItems.length - 1 : prev - 1));
  };

  const handleDelete = (item: IMediaItem) => {
    modalConfirmRef.current?.open(() => deleteItem(item), {
      message: `Do you want to delete this ${item.type.toLowerCase()}?`,
    });
  };

  const deleteItem = async (item: IMediaItem) => {
    try {
      const res = await mediaApis.deleteMediaItem(item.id);

      if (res?.data) {
        toast.success('Deleted successfully.');
        navigate('/media', { replace: true });
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'An error occurred while deleting the item.');
    }
  };

  const handleSetToScreen = () => {
    navigate('/set-to-screen', {
      state: {
        mediaId: item.id,
      },
    });
  };

  return (
    <Container>
      <HeaderMobile title={item?.name || 'Media Detail'} />
      <Content>
        {RenderMedia(item, 0, true)}
        <Navigation>
          <button onClick={handlePrev}>
            <IcChevronLeft width={28} height={28} />
          </button>
          <button onClick={handleNext}>
            <IcChevronRight width={28} height={28} />
          </button>
        </Navigation>
      </Content>
      <FooterMobile>
        <Button
          lg
          type_delete
          prefix={<IcTrash width={20} height={20} fill={Colors.other[3]} />}
          onClick={() => item && handleDelete(item)}
        >
          Delete
        </Button>
        <Button lg type_second prefix={<IcScreen width={20} height={20} fill={Colors.neutral.bg[1]} />} onClick={handleSetToScreen}>
          Set to Screen
        </Button>
      </FooterMobile>
      <ModalConfirm ref={modalConfirmRef} />
    </Container>
  );
};

export default MediaDetail;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;

  .type_delete,
  .type_second {
    padding: 0px 8px;
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  .custom-media {
    width: 100%;
    height: 192.938px !important;
    align-self: stretch;
    aspect-ratio: 16/9 !important;
    position: relative !important;
  }
`;

const Navigation = styled.div`
  position: absolute;
  bottom: 100px;
  display: flex;
  gap: 24px;
`;
